import React, { useState } from "react";
import NewPagination from "./Pagination/NewPagination";
// import MyDeliveryModal from "../Modals/MyDeliveryModal";
import { LanguageContext } from "../../Languages/LanguageContext";
import { useContext } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { resendCode } from "../../../features/dashboard/newBuilderSlice";
import {
  fetchMyDeliveries,
  verifyCode,
} from "../../../features/dashboard/newBuilderSlice";
import toast from "react-hot-toast";
import { fetchDeliveryPartner } from "../../../features/dashboard/newBuilderSlice";
import { createManualDeliveryRequest } from "../../../features/dashboard/newBuilderSlice";
import CreateDeliveryRequestModal from "../Modals/CreateDeliveryRequestModal";

import OtpModal from "../../auth/OTPModal";
import { calculateDeliveryFee } from "../../../features/dashboard/newBuilderSlice";
const MyDelivery = () => {
  const [page, setPage] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [limit] = useState(10);
  const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showCreateRequestModal, setShowCreateRequestModal] = useState(false);
  const role = useSelector((state) => state?.auth.user?.role);
  const [partnerPage, setPartnerPage] = useState(1);
  const [partnerLimit] = useState(10);
  const [calculating, setCalculating] = useState(false);
  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();
  const { t } = useContext(LanguageContext);
  const {
    mydeliveries,
    deliveryPartners,
    loading,
    myDeliveriesLoading,
    myDeliveryError,
  } = useSelector((state) => state.dashboard || {});

  useEffect(() => {
    dispatch(fetchMyDeliveries({ page, limit }));
  }, [dispatch, page, limit]);

  const deliveries = mydeliveries?.data || [];
  const pagination = mydeliveries?.pagination || { total_pages: 1 };

  const handleReload = () => {
    dispatch(fetchMyDeliveries({ page, limit }));
  };

  const handleResendOtp = (delivery_id) => {
    dispatch(resendCode(delivery_id))
      .unwrap()
      .then((res) => {
        toast.success("Code resent successfully!");
        setSelectedDeliveryId(delivery_id);
        setShowOtpModal(true);
      })
      .catch((err) => {
        console.error(err);
        toast.error(err?.message || "Failed to resend OTP");
      });
  };

  const handleCalculateFee = async (e, formData, setFormData) => {
    e.preventDefault();

    const { customer_address, store_address } = formData;

    if (!customer_address || !store_address) {
      toast.error("Please fill both addresses before calculating the fee");
      return;
    }

    try {
      setCalculating(true);

      const result = await dispatch(
        calculateDeliveryFee({
          customer_address: customer_address.trim(),
          store_address: store_address.trim(),
        }),
      ).unwrap();
      console.log("calculateDeliveryFee result:", result); // 👈 HERE
      setFormData((prev) => ({
        ...prev,
        delivery_fee: result.data.delivery_fee,
        delivery_distance: result.data.distance,
        unit: result.data.unit,
      }));

      toast.success("Delivery fee calculated successfully!");
    } catch (error) {
      console.error("Error calculating delivery fee:", error);
      toast.error(error?.message || "Failed to calculate delivery fee");
    } finally {
      setCalculating(false);
    }
  };

  const handleCreateManualRequest = () => {
    setPartnerPage(1);

    setShowCreateRequestModal(true);
  };

  const handleOtpSubmit = () => {
    if (!/^\d{6}$/.test(otp)) {
      alert("Please enter a valid 6-digit Code");
      return;
    }

    const data = {
      delivery_code: otp,
    };

    dispatch(verifyCode(data))
      .unwrap()
      .then((res) => {
        toast.success(res?.message || "Code verified successfully!");

        setOtp("");

        setShowOtpModal(false);

        dispatch(fetchMyDeliveries({ page, limit }));
      })
      .catch((err) => {
        console.error("OTP Error ", err);
        setOtpError(err.message || "Please enter a valid code");
      });
  };

  const handleDeliveryRequest = async (formData, resetForm) => {
    setSaving(true);
    try {
      const result = await dispatch(
        createManualDeliveryRequest(formData),
      ).unwrap();

      toast.success(
        result?.message || "Delivery request created successfully!",
      );

      if (resetForm) resetForm();

      setShowCreateRequestModal(false);

      dispatch(fetchMyDeliveries({ page, limit }));
    } catch (error) {
      const errorMessage =
        error?.payload?.detail ||
        error?.detail ||
        error?.message ||
        "Failed to create delivery request";

      toast.error(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid ">
      <div className="d-flex flex-sm-row flex-column justify-content-sm-between justify-content-center mb-3">
        <div className="text-left fw-bold mb-2 mb-sm-0  fs-4 text-light">
          {t?.mydeliveries || "My Deliveries"}
        </div>
        <div className="d-flex justify-content-end align-items-center gap-2">
          {role === "company" && (
            <button
              className="btn  btn-success "
              onClick={handleCreateManualRequest}
            >
              Create Delivery Request
            </button>
          )}
          <div
            className="btn btn-sm btn-light d-flex justify-content-center align-items-center text-white"
            style={{ cursor: "pointer", width: "35px", height: "35px" }}
            onClick={handleReload}
          >
            <i className="bi bi-arrow-clockwise fs-5"></i>
          </div>
        </div>
      </div>
      {myDeliveriesLoading && !showOtpModal && (
        <div className="text-center text-warning fw-bold">
          Loading my deliveries...
        </div>
      )}

      {myDeliveryError && (
        <div className="text-center text-danger fw-bold">
          Error: {myDeliveryError}
        </div>
      )}

      {(!myDeliveriesLoading || showOtpModal) && !myDeliveryError && (
        <div className="table-responsive">
          <table className="table bg-light table-bordered table-hover align-middle text-center text-info">
            <thead className="table-light">
              <tr>
                <th className="text-info">Delivery ID</th>
                <th className="text-info">Name</th>
                <th className="text-info">Email</th>
                <th className="text-info">Phone</th>
                <th className="text-info">Customer Address</th>
                <th className="text-info">Store Address</th>
                <th className="text-info">Delivery Fee</th>
                <th className="text-info">Created At</th>
                <th className="text-info">Status</th>
                {role !== "company" && <th className="text-info">Action</th>}
              </tr>
            </thead>
            <tbody>
              {deliveries.length > 0 ? (
                deliveries.map((delivery) => (
                  <React.Fragment key={delivery.id}>
                    <tr>
                      <td>{delivery.id}</td>
                      <td>{delivery.customer_name}</td>
                      <td>{delivery.customer_email}</td>
                      <td>{delivery.customer_phone}</td>
                      <td style={{ fontSize: "14px" }}>
                        {delivery.customer_address}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {delivery.store_address}
                      </td>
                      <td>{delivery.delivery_fee}</td>
                      <td>
                        {new Date(delivery.created_at)
                          .toISOString()
                          .slice(0, 10)}
                      </td>
                      <td>{delivery.status}</td>
                      {role !== "company" && (
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            {delivery.status !== "delivered" && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleResendOtp(delivery.id)}
                              >
                                Resend OTP
                              </button>
                            )}
                            {delivery.status === "delivered" ? (
                              <button
                                className="btn btn-sm btn-success"
                                disabled
                              >
                                Verified
                              </button>
                            ) : (
                              <button
                                className="btn btn-sm btn-light text-info"
                                onClick={() => {
                                  setSelectedDeliveryId(delivery.id);
                                  setShowOtpModal(true);
                                }}
                              >
                                Verify Code
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center text-muted py-3">
                    No deliveries found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <CreateDeliveryRequestModal
        show={showCreateRequestModal}
        onClose={() => setShowCreateRequestModal(false)}
        onSave={handleDeliveryRequest}
        limit={partnerLimit}
        page={partnerPage}
        setPage={setPartnerPage}
        handleFee={handleCalculateFee}
        calculating={calculating}
        saving={saving}
      />

      {showOtpModal && (
        <OtpModal
          otp={otp}
          setOtp={setOtp}
          onSubmit={handleOtpSubmit}
          onClose={() => setShowOtpModal(false)}
          otpError={otpError}
          setOtpError={setOtpError}
          title="Enter Code"
        />
      )}

      {/* Pagination */}
      {!myDeliveriesLoading && !myDeliveryError && (
        <NewPagination
          page={pagination.page || page}
          totalPages={pagination.total_pages || 1}
          setPage={setPage}
        />
      )}
    </div>
  );
};

export default MyDelivery;
